const carouselItems = [
  {
    title: '七月最值得追的日漫新番榜单',
    tag: '新番推荐',
    desc: '本季日漫新番质量爆表，从《咒术回战》续作到多部原创动画，51动漫官网全部收录支持免费追更。',
    img: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20with%20multiple%20Japanese%20animation%20characters%20in%20summer%20festival%20setting%20warm%20golden%20hour%20lighting%20vibrant%20colors%20with%20fireworks%20and%20lanterns%20cinematic%20wide%20composition%20clean%20aesthetic&width=800&height=400&seq=carousel-card-01&orientation=landscape',
  },
  {
    title: '国漫仙侠玄幻巅峰对决 — 年度大作盘点',
    tag: '国漫精选',
    desc: '国漫市场持续爆发，仙侠玄幻类作品凭借精良制作和宏大世界观成为漫友追番主力。51动漫官网同步更新。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20style%20epic%20landscape%20with%20floating%20mountains%20and%20ancient%20palaces%20warm%20golden%20and%20coral%20color%20palette%20ethereal%20misty%20atmosphere%20cinematic%20wide%20composition%20clean%20aesthetic&width=800&height=400&seq=carousel-card-02&orientation=landscape',
  },
  {
    title: '韩漫热潮来袭 — 这些作品正在改写行业',
    tag: '韩漫专题',
    desc: '韩漫凭借独特画风和紧凑剧情迅速走红，51动漫官网韩漫频道收录大量热门连载作品，下拉式阅读完美适配。',
    img: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20with%20modern%20Seoul%20cityscape%20and%20stylish%20character%20silhouettes%20warm%20sunset%20peach%20and%20lavender%20color%20palette%20atmospheric%20cinematic%20wide%20composition%20clean%20aesthetic&width=800&height=400&seq=carousel-card-03&orientation=landscape',
  },
  {
    title: '经典老番重温 — 那些年我们追过的神作',
    tag: '经典回顾',
    desc: '从《钢之炼金术师》到《Clannad》，51动漫官网经典老番专区收录百余部高分动漫，适合新老漫友收藏重温。',
    img: 'https://readdy.ai/api/search-image?query=Nostalgic%20anime%20style%20illustration%20with%20classic%20animation%20characters%20in%20warm%20vintage%20film%20grain%20aesthetic%20sepia%20and%20golden%20color%20palette%20memorable%20cinematic%20wide%20composition%20clean%20aesthetic&width=800&height=400&seq=carousel-card-04&orientation=landscape',
  },
  {
    title: '动漫电影特辑 — 大银幕上的动画艺术',
    tag: '动画电影',
    desc: '21部必看动漫电影推荐，从宫崎骏到新海诚，每一帧都是壁纸。51动漫官网高清画质在线观看，支持免费下载。',
    img: 'https://readdy.ai/api/search-image?query=Anime%20movie%20style%20cinematic%20scene%20with%20dreamy%20sky%20and%20floating%20islands%20warm%20sunset%20color%20palette%20with%20pink%20orange%20and%20golden%20hues%20emotional%20atmosphere%20wide%20composition%20clean%20aesthetic&width=800&height=400&seq=carousel-card-05&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          焦点推荐
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className={`bg-background-100/80 rounded-xl overflow-hidden hover:bg-background-100 transition-colors duration-200 cursor-pointer ${
                i < 2 ? 'lg:col-span-1' : ''
              }`}
            >
              <div className="relative aspect-[2/1] bg-background-200 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
                <span className="absolute top-3 left-3 text-xs font-medium bg-background-50/90 text-primary-600 px-2.5 py-1 rounded-full">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}